import React, { useEffect, useState } from "react";
import { Card, Spinner, Form } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";

import CustomPagination from "Common/customPagination";
import { authServices } from "Utils/auth/services";
import PlUserBetEventWise from "Common/Tables/eventWiseTable/plUserBetEventWise";

interface UserSettledBetPayload {
  match_id: string;
  page: number;
  limit: number;
  search: {
    fancy_id: string;
    user_id: string;
  };
}

const PlUserBet: React.FC = () => {
  const { match_id,fancy_id,id} = useParams<{ match_id: string,fancy_id:string,id:string }>();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [casinoBetsData, setCasinoBetsData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(50);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const isPlUserBetPage = location.pathname.includes("/plUserBet");

  const getEventPlData = async (page: number = 1, limit: number = 50) => {
    if (!match_id) return;

    setIsLoading(true);
    try {
      const payload: UserSettledBetPayload = {
        match_id: match_id, // You might want to replace this with dynamic `matchId`
        page: currentPage, // Use currentPage
        limit: itemsPerPage, // Use itemsPerPage
        search: {
          fancy_id: String(fancy_id), // Use dynamic `fancyId`
          user_id: String(id), // Use dynamic `user_id`
        },
      };

      const { response } = await authServices.getsetteledBet(payload);
      if (response?.data) {
        setCasinoBetsData(response.data);
        setTotalItems(response.total || 0);
      } else {
        setCasinoBetsData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching casino bets data:", error);
      setCasinoBetsData([]);
      setTotalItems(0);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getEventPlData(page, itemsPerPage);
  };

  const handleItemsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newItemsPerPage = Number(event.target.value);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
    getEventPlData(1, newItemsPerPage);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const handleRowClick = (event_id: string, sport_id: string) => {
    // console.log("Row clicked:", event_id, sport_id);
  };

  useEffect(() => {
    getEventPlData(currentPage, itemsPerPage);
  }, [match_id]);

  return (
    <div className="event-pl">
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex gap-2 align-items-center">
              Show
              <select
                className="form-select w-auto"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={150}>150</option>
                <option value={200}>200</option>
              </select>
              Entries
            </div>

            {!isPlUserBetPage && (
              <Form.Control
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange}
                className="w-25"
              />
            )}
          </div>

          {isLoading ? (
            <div className="text-center">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <>
              <PlUserBetEventWise
                fancyPLData={casinoBetsData}
                onClickRow={handleRowClick}
                // searchTerm={searchTerm}
              />
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
              />
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PlUserBet;
